import { Title, Text, Flex } from "@mantine/core";
import React from "react";

interface ArticleUtilProps {
  children: React.ReactNode;
}

interface ReferenceItemProps {
  number: number;
  children: React.ReactNode;
  mobile?: boolean;
}

export const ArticleText = ({ children }: ArticleUtilProps) => (
  <Text
    fz={{ base: "md", sm: "lg" }}
    mt="sm"
    mb="sm"
    w="100%"
    ta="justify"
    px={{ base: "sm", sm: 0 }}
  >
    {children}
  </Text>
);

export const NumberedText = ({ children }: ArticleUtilProps) => (
  <Text fz={{ base: "md", sm: "lg" }} mt="sm" mb="sm" w="95%" ta="justify" pr="sm" pl="lg">
    {children}
  </Text>
);

export const NumberText = ({ children }: ArticleUtilProps) => (
  <Title size="h4" mb="sm" c="gray.6" pl="lg">
    {children}
  </Title>
);

export const TitleSmall = ({ children }: ArticleUtilProps) => (
  <Title fz={{ base: "h4", sm: "h3" }} my="sm" px={{ base: "sm", sm: 0 }}>
    {children}
  </Title>
);

export const ReferenceItem = ({ number, children }: ReferenceItemProps) => (
  <Flex mb="sm">
    <Text ml="xl" fz={{ base: "sm", sm: "md" }} c="dimmed">
      {number}.
    </Text>
    <Text ml="xl" fz={{ base: "sm", sm: "md" }} c="dimmed" w="80%">
      {children}
    </Text>
  </Flex>
);

export const ReferenceLink = ({ href, children }: { href: string; children: React.ReactNode }) => (
  <Text component="a" href={href} target="_blank" rel="noopener noreferrer" lineClamp={1}>
    {children}
  </Text>
);
